<script setup>
import careDayWeiss3 from "assets/graphics/img/careday-weiss.svg";

const emit = defineEmits(["logoClick"]);

const LONG_PRESS_TIME_MS = 1500;

let checkTime = null;

const handlePressStart = () => {
  checkTime = setTimeout(() => {
    checkPress();
  }, LONG_PRESS_TIME_MS);
};

const handlePressEnd = () => {
  clearTimeout(checkTime);
  checkTime = null;
};

const checkPress = () => {
  if (checkTime) {
    emitLogoClickEvent();
    checkTime = null;
  }
};

const emitLogoClickEvent = () => {
  emit("logoClick");
};
</script>

<template>
  <div class="info-logo centered cb_remove_on_mobile">
    <img
      class="info-logo-image"
      :src="careDayWeiss3"
      alt=""
      @touchstart="handlePressStart"
      @touchend="handlePressEnd"
    >
  </div>
</template>

<style scoped>
.info-logo {
  width: 100%;
}

.info-logo-image {
  width: 100%;
  padding-bottom: 1rem;
}

@media (min-width: 3200px) {
  .info-logo-image {
    padding-bottom: 2rem;
  }
}
</style>
